import type { ReactNode } from 'react';
import { type Props as ReactModalProps } from 'react-modal';

import { Modal } from '../../../../components/ToolkitV2/Modal/Modal';
import { Text } from '../../../../components/ToolkitV2/Text/Text';

import { defaultTheme } from 'styled-system';

import { Header, HeaderIcon } from './MakeModelKeywordSearchModal.styled';

type MakeModelKeywordSearchModalProps = {
  children: ReactNode;
} & Pick<ReactModalProps, 'onRequestClose' | 'isOpen'>;

export const MakeModelKeywordSearchModal = (
  props: MakeModelKeywordSearchModalProps,
) => {
  const { onRequestClose, children, ...rest } = props;

  return (
    <Modal
      borderRadius={`${defaultTheme.borderRadius.default} ${defaultTheme.borderRadius.default} 0 0`}
      padding="0"
      height="100%"
      width="100%"
      contentLabel="Make Model Keyword Search Modal"
      modalClassName="make-model-keyword-search"
      onRequestClose={onRequestClose}
      {...rest}
    >
      <Header onClick={onRequestClose} aria-label="Close modal">
        <Text size="M16" weight="bold" color="GREY_DARKER">
          Make & model
        </Text>
        <HeaderIcon />
      </Header>
      {children}
    </Modal>
  );
};
